// extracted by mini-css-extract-plugin
module.exports = {"container":"gC-z","productName":"hC-z","modal":"iC-z","dimensions":"jC-z","recipientEmail":"kC-z","lowStock":"lC-z","recommendedFit":"mC-z"};